module.exports = __webpack_public_path__ + "b0be63e04f6f96588c48d0b8a6473512.png";